/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Staff_Login_LinkInputs */

const cs_portal_staff_login_link = /** @type {(inputs: Portal_Staff_Login_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení pro staff`)
};

const en_portal_staff_login_link = /** @type {(inputs: Portal_Staff_Login_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staff sign-in`)
};

/**
* | output |
* | --- |
* | "Staff sign-in" |
*
* @param {Portal_Staff_Login_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_staff_login_link = /** @type {((inputs?: Portal_Staff_Login_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Staff_Login_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_staff_login_link(inputs)
	return cs_portal_staff_login_link(inputs)
});